var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"catpage",attrs:{"id":"category"}},[_c('div',{staticClass:"container-fluid"},[_c('h1',{staticClass:"cat-title"},[_vm._v(_vm._s(_vm.catInfo.name))]),_vm._v(" "),_c('app-tile',{attrs:{"name":'Project',"array":_vm.activeProjects}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-555931cf","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Portfolio/Category.vue
// module id = null
// module chunks = 